import { Stack } from "@mui/material";
import { UnderlinedLabel } from "./UnderlinedLabel";

const SignatureSection = () => (
  <Stack direction="row" gap="15px" height="50px">
    <UnderlinedLabel label="Signature" width="65%" />
    <UnderlinedLabel label="Date" width="35%" />
  </Stack>
);

export default SignatureSection;
